import React, { useState } from 'react';
import styled from 'styled-components';
import { Card, date } from 'shared';
import { Button, SmallBody, Tag, TinyTitle } from '@indigo-ag/component-module';
import { FeedbackVariants } from '@indigo-ag/component-module/dist/commonjs/shared/theme/theme-helpers/feedback';
import i18next from 'i18next';

const CardContainer = styled.div`
  height: 100%;
  flex: 1;
  min-width: 300px;
`;

const CardContentContainer = styled.div`
  min-height: 74px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

interface SerasaBacenCardProps {
  report: {
    annotationType: string;
    date?: Date;
    statusMessage: string;
  };
  statusTag: {
    label: string;
    variant: FeedbackVariants;
  };
  modal: {
    show: (open: boolean, onRequestClose: () => void) => React.ReactNode;
  };
  restriction?: boolean;
  buttonSlot?: React.ReactNode;
}

export const SerasaBacenCard = ({ report, modal, statusTag, restriction, buttonSlot }: SerasaBacenCardProps) => {
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const getFormattedReportDate = () => (report?.date ? date.formatDate(report.date) : '-');

  return (
    <>
      {modal.show(detailModalOpen, () => setDetailModalOpen(false))}
      <CardContainer>
        <Card
          title={
            <TinyTitle style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
              {report.annotationType}
            </TinyTitle>
          }
          topRightContent={<Tag label={statusTag.label} variant={statusTag.variant} hideIcon />}
        >
          <CardContentContainer>
            <SmallBody style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', marginTop: '1rem' }}>
              <span>
                {i18next.t('serasaAnnotationCard_consultationDate', {
                  consultationDate: getFormattedReportDate()
                })}
              </span>
              <span>{i18next.t('serasaAnnotationCard_status', { status: report.statusMessage })}</span>
            </SmallBody>
          </CardContentContainer>

          <ButtonsWrapper>
            {buttonSlot}
            <Button onClick={() => setDetailModalOpen(true)} size="small" variant="tertiary" disabled={!!restriction}>
              {i18next.t('detailButtonLabel')}
            </Button>
          </ButtonsWrapper>
        </Card>
      </CardContainer>
    </>
  );
};
